import React, { useState } from 'react';
import LoginForm from './LoginForm';
import BannerLogin from './BannerLogin';
import NavigationBar from './NavigationBar';
import Footer from './Footer'; // Import the VolunteerFooter component
import Onboard from './Onboard';

const PageLogin = ({gotoOnboard}) => {
  const [displayContent, setDisplayContent] = useState(true);

  const [onboard, setOnboard] = useState(false)
  const changeOnboard = (newValue) => {
    setOnboard(newValue)
    gotoOnboard(newValue)
  }

  return (
    <div >
      {displayContent && !onboard && <BannerLogin changeOnboard={changeOnboard} />}
      {/* {displayContent && !onboard && <LoginForm />} */}
      {/* {!onboard && <NavigationBar setDisplayContent={setDisplayContent} />} */}
      {onboard && <Onboard changeOnboard={changeOnboard}/>}
      {/* <div style={{ marginTop: '1100px' }} />  */}
      {/* <Footer style={{ marginTop: '200px' }} />  */}
    </div>
  );
};

export default PageLogin;

